import React from "react";
import { useDispatch } from "react-redux";
import clsx from "clsx";

import Button from "@material-ui/core/Button";
import AddRiskIcon from "@material-ui/icons/AddCircle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

import { setIsAddCustomRiskPopupOpen } from "store/actions/vetHorseDetailsPage";
import Breakpoints from "common/breakpoints";

import useStyles from "./styles";

interface IProps {
  className?: string;
}

const AddCustomRiskButton = (props: IProps) => {
  const { className } = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const matchesDownXS = useMediaQuery(
    theme.breakpoints.down(Breakpoints.XS_420)
  );

  const handleOpenAddCustomRiskPopup = event => {
    event.stopPropagation();
    dispatch(setIsAddCustomRiskPopupOpen(true));
  };

  const buttonTitle = matchesDownXS ? "Add Risk" : `Add Custom Risk`;

  return (
    <Button
      className={clsx(classes.addRiskButton, className)}
      endIcon={<AddRiskIcon className={classes.icon} />}
      onClick={handleOpenAddCustomRiskPopup}
    >
      {buttonTitle}
    </Button>
  );
};

export default React.memo(AddCustomRiskButton);
